import type { FC, SVGProps } from 'react';

export const ConfluenceLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 256 246"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <defs>
      <linearGradient
        id="confluence-a"
        x1="99.14%"
        x2="33.86%"
        y1="112.05%"
        y2="70.47%"
      >
        <stop offset="0%" stopColor="#0052CC" />
        <stop offset="92.3%" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="confluence-b"
        x1="0.86%"
        x2="66.14%"
        y1="-12.05%"
        y2="29.53%"
      >
        <stop offset="0%" stopColor="#0052CC" />
        <stop offset="92.3%" stopColor="#2684FF" />
      </linearGradient>
    </defs>
    <path
      d="M9.26 187.28c-3.83 6.27-8.1 13.64-11.05 18.89a8.18 8.18 0 0 0 3.06 11.16l57.39 34.5a8.18 8.18 0 0 0 11.2-2.72c2.5-4.2 5.87-9.83 9.6-15.92 26.62-43.47 53.4-38.17 102.34-16.3l58.27 25.88a8.18 8.18 0 0 0 10.76-4.27l26.19-60.17a8.18 8.18 0 0 0-4.18-10.61c-16.63-7.39-49.66-22.05-67.21-29.85C132.54 104.63 50.48 118.31 9.26 187.28Z"
      fill="url(#confluence-a)"
    />
    <path
      d="M246.74 58.72c3.83-6.27 8.1-13.64 11.05-18.89a8.18 8.18 0 0 0-3.06-11.16L197.34-5.83a8.18 8.18 0 0 0-11.2 2.72c-2.5 4.2-5.87 9.83-9.6 15.92-26.62 43.47-53.4 38.17-102.34 16.3L16.15 3.22a8.18 8.18 0 0 0-10.76 4.28L-20.8 67.67a8.18 8.18 0 0 0 4.18 10.61c16.63 7.39 49.66 22.05 67.21 29.85 72.89 32.25 154.95 18.57 196.16-49.41Z"
      fill="url(#confluence-b)"
    />
  </svg>
);
